module.exports = __webpack_public_path__ + "flag_swiss.png?6758dc2142507249024737cde79aedae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag_swiss.png
// module id = 37
// module chunks = 0